import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from '@astek/utils';
import {PressureUnitUtils} from '../../core/utils/pressure-unit-utils';
import {PressureUnitEnum} from '../../core/services/state/pressure-unit.enum';

@Pipe({
  name: 'xpMmHgToUnit',
})
export class MmHgToUnitPipe implements PipeTransform {

  constructor() {
  }

  public transform(
    value: number | null | undefined,
    unit: PressureUnitEnum,
  ): number | null {
    if (Utils.isNullOrUndefined(value)) {
      return null;
    }
    return PressureUnitUtils.convertMmHgToUnit(value, unit);
  }

}
